


























import { mapActions, mapGetters } from "vuex";
import { Home } from "@/utils/constants";
export default {
  name: "SuiteNumbers",
  data() {
    return {
      Home
    };
  },

  computed: {
    ...mapGetters({
      suiteNumbers: "getSuiteNumbers",
      isContrast: "isContrast"
    }),

    suiteNumbersList() {
      return [
        {
          icon: "note-multiple",
          field: "total_processes",
          title: Home.SuiteNumbers.PROCESSES_OPENED,
          date: "last_update"
        },
        {
          icon: "note-plus",
          field: "process_average",
          title: Home.SuiteNumbers.PROCESS_AVERAGE,
          date: "last_average_update"
        },
        {
          icon: "account-group",
          field: "total_users",
          title: Home.SuiteNumbers.ACTIVE_USERS,
          date: "last_update"
        },
        {
          icon: "bank",
          field: "total_parts",
          title: Home.SuiteNumbers.ORGANS_USING,
          date: "last_update"
        }
      ];
    }
  },

  beforeMount() {
    this.requestSuiteNumbers();
  },

  methods: {
    ...mapActions({
      requestSuiteNumbers: "requestSuiteNumbers"
    }),

    useField(fieldName: string) {
      if (this.suiteNumbers[fieldName] !== undefined)
        return this.suiteNumbers[fieldName];
      return "-";
    }
  }
};
